class ICategory {
    public id: number = 0;
    public name: string = '';
    public description: string = '';
}

class IContractor {
    public id: string = "";
    public contractorName: string = '';
    public groupEmail: string | number = '';
    public erpId: string = '';
    public groupEmails: IGroupEmail[] = [];
}

interface ITaxRate {
    id: string;
    rate: number;
    description: string;
}

class TaxRate implements ITaxRate {
    public id = '';
    public rate = '' as unknown as number;
    public description = '';
}


class IItemPrice {
    public id: string;
    public regionId: string;
    public name: string;
    public price: number;
    public cost: number;
    public isTaxable: boolean;
}

class IRegionProductPrice extends IItemPrice {
    public productId: string;
    public size: string;
    public unit: string;
    public weight: string;
    public specificGravity: string;
    public category: string;
}

class IOperatorRegionPrice extends IRegionProductPrice {
    public operatorId: string;
    public effectiveDate: string;
    public copyEffectiveDate: string;
    constructor(price?: Partial<IRegionProductPrice>, operatorId?: string) {
        super();
        if (price) {
            Object.assign(this, price);
        }
        if (operatorId) {
            this.operatorId = operatorId;
        }
    }
}

class IWellList {
    public wellId: string;
    public wellName: string;
    public effectiveDate: string;
    public operatorId: string;
    public regionId: string;
    public wellStatus: string;
}

class IRegionExpensePrice extends IItemPrice {
    public expenseId: string;
    public isRental: boolean;
}

class IOperatorRegionExpensePrice extends IRegionExpensePrice {
    public operatorId: string;
    public effectiveDate: string;
    public copyEffectivedate: string;
    constructor(price: Partial<IRegionExpensePrice>, operatorId?: string) {
        super();
        if (price) {
            Object.assign(this, price);
        }
        if (operatorId) {
            this.operatorId = operatorId;
        }
    }
}

class GroupEmail implements IGroupEmail {
    public id = '';
    public email = '';
    public description = '';
}

interface IGroupEmail {
    id: string;
    email: string;
    description: string;
}

class Role implements IRole {
    public id = '';
    public permissions = [] as string[];
    public description = '';
    public name = '';
}

interface IRole {
    id: string;
    name: string;
    description: string;
    permissions: string[];
}

class ISolidsControlEquip {
    public id: string = "";
    public sizeScreens: string = '';
    public deviceName: string = '';
    public makeModel: string = '';
}

class IWarehouse {
    public id: string = "";
    public name: string = '';
    public phone: string | number = '';
    public addr1: string = '';
    public addr2: string = '';
    public city: string = '';
    public state: string = '';
    public zip: string = '';
}

class IOptionFieldListItem {
    public fieldItemName: string = '';
    public id: string = '';
    public optionalFieldListId: string = '';
}

class IOptionFieldList {
    public id: string = '';
    public fieldListName: string = '';
    public optionalFieldListItems: IOptionFieldListItem[] = [];
    public routeName: string = '';
}

class IUnitOfMeasure {
    public id: string = '';
    public name: string = '';
    public unitSize: Array<number | string> = [];
}

export {
    ICategory,
    IContractor,
    IGroupEmail,
    IOperatorRegionPrice,
    IOperatorRegionExpensePrice,
    IOptionFieldList,
    IOptionFieldListItem,
    IRegionProductPrice,
    IRegionExpensePrice,
    IRole,
    ISolidsControlEquip,
    ITaxRate,
    IUnitOfMeasure,
    IWarehouse,
    IWellList,
    GroupEmail,
    Role,
    TaxRate,
};


// WEBPACK FOOTER //
// ./src/Interfaces/AdminInterface.tsx